module.exports = __webpack_public_path__ + "static/media/M42_logo.dc026a5a.png";